export default __webpack_public_path__ + "static/media/long.0f8a81b9.svg";